import { request } from "@/lib/api";

export interface RnCorrectionRequest {
    id: number;
    askId: number;
    visitId: number;
    questions: { questionId: number; sectionId: number; text: string }[];
    answers: { questionId: number; text: string }[] | null;
    answeredAt: string | null;
    createdAt: string;
}
export const fetchCorrectionRequests = () =>
    request<RnCorrectionRequest[]>("/rn/me/correction-requests");
export const submitCorrectionAnswers = (
    id: number,
    answers: { questionId: number; text: string }[]
) =>
    request(`/rn/me/correction-requests/${id}/submit`, {
        method: "POST",
        body: JSON.stringify({ answers })
    });
